import { request } from "@/interface/helper";

const str = "marketingMarkForm";

export const marketingMarkForm = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/form/list" }),
    detail: (data) => request({ data, method: "post", url: "/form/detail" }),
    edit: (data) => request({ data, method: "post", url: "/form/modify" }),
  },
};
